import React, { useEffect, useState } from "react";
import {
  collection,
  onSnapshot,
  query,
  orderBy,
} from "firebase/firestore";
import { db } from "../../services/firebaseConfig";
import "./readonlychatbox.css";

const ReadOnlyChatBox = ({ hashcode }) => {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    if (!hashcode) return;

    const q = query(
      collection(db, `sharedChats/${hashcode}/messages`),
      orderBy("timestamp", "asc")
    );

    const unsub = onSnapshot(q, (snapshot) => {
      const msgs = snapshot.docs.map((doc) => doc.data());
      setMessages(msgs);
    });

    return () => unsub();
  }, [hashcode]);

  return (
    <div className="chatbox-admin-container">
      <h6>Chat Conversation</h6>

      {messages.length === 0 ? (
        <div className="no-chat">No chat history available.</div>
      ) : (
        messages.map((msg, idx) => (
          <div key={idx} className={`chat-msg ${msg.from}`}>
            {msg.fileUrl && msg.fileType === "image" && (
              <img
                src={msg.fileUrl}
                alt="Attachment"
                className="chat-image"
              />
            )}

            {msg.fileUrl && msg.fileType === "file" && (
              <a
                href={msg.fileUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="chat-file"
              >
                📎 View File
              </a>
            )}

            {msg.text && (
              <div className="chat-text">
                <strong>{msg.from}</strong>: {msg.text}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default ReadOnlyChatBox;
